import { Grid, InputAdornment, TextField } from "@material-ui/core";
import React, { FC, useState } from "react";
import { useStyles } from "./styles";
import SearchIcon from "@mui/icons-material/Search";

interface CompaniesSearchByProps {
  defaultSearchText?: string;
  handleSearch: (searchText: string) => void;
}
export const CompaniesSearchBy: FC<CompaniesSearchByProps> = ({ defaultSearchText = "", handleSearch }) => {
  const styles = useStyles();
  const [searchText, setSearchText] = useState<string>(defaultSearchText);

  const handleChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(value);
    handleSearch(value);
  };

  return (
    <TextField
      value={searchText}
      className={styles.searchFiled}
      variant="outlined"
      data-testid="search-input"
      size="small"
      onChange={handleChange}
      fullWidth
      placeholder="Search by Company Legal Name, CIF, CRM ID, Team Code, or Codat ID"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon className={styles.searchIcon} />
          </InputAdornment>
        ),
      }}
    />
  );
};
